import React, { Component, Fragment } from 'react';
import { Checked } from '../../../Assets/List/ListIcons';
import getDate from '../../../Helpers/Date/GetDate';
import FormAction from '../FormAction';
import { t } from 'i18next';
class BulkAddIssuedPurchaseOrders extends Component {
  state = {
    selectedData: [],
  };

  selectAll = (event) => {
    let selectedData = [];
    if (event.target.checked) {
      selectedData = [...this.props.purchaseOrdersList];
      this.props.updateissuedPO(this.props.purchaseOrdersList.length);
    } else {
      selectedData = [];
      this.props.updateissuedPO(0);
    }
    this.setState({ selectedData });
  };

  selectSingle = (event) => {
    const id = parseInt(event.target.name, 10);

    if (event.target.checked) {
      const selectedItem = this.props.purchaseOrdersList.find(
        (one) => one.id === id
      );
      this.setState({
        selectedData: [...this.state.selectedData, selectedItem],
      });
      this.props.updateissuedPO(this.state.selectedData.length + 1);
    } else {
      const restCheckedItems = this.state.selectedData.filter(
        (one) => one.id !== id
      );
      this.setState({
        selectedData: restCheckedItems,
      });
      this.props.updateissuedPO(this.state.selectedData.length - 1);
    }
  };

  handleSubmit = () => {
    if (this.state.selectedData.length > 5) {
      this.props.handleToast(t('Invoice.select_five_so'), 'error');
      return;
    }
    if (!this.state.selectedData.length) {
      this.props.handleToast(
        t('common.select_at_least_one_purchase_order'),
        'error'
      );
      return;
    }
    const { onSubmit } = this.props;
    onSubmit(this.state.selectedData);
  };

  renderTable() {
    const { purchaseOrdersList, onClose, loader } = this.props; //currency,
    const { selectedData } = this.state;
    return loader ? (
      <div className="issued_SO_PO bulk_inv">
        <span className="test">{t('Items.bulk_items.wait')}</span>{' '}
      </div>
    ) : (
      <Fragment>
        <div className="issued_SO_PO">
          <table className="list-table border">
            <thead>
              <tr>
                <th>
                  <label className="list-table--checkbox-lable pointer">
                    <input
                      checked={
                        selectedData.length === purchaseOrdersList.length
                      }
                      type="checkbox"
                      onChange={this.selectAll}
                    />
                    <span>
                      <Checked />
                    </span>
                  </label>
                </th>
                <th>{t('bill.purchase_order_no')}</th>
                <th>{t('report.Fifo.date')}</th>
                <th className="right-align" style={{ paddingRight: '2rem' }}>
                  {t('report.purchase_order_report_table.amount')}
                </th>
              </tr>
            </thead>
            <tbody>
              {purchaseOrdersList.map((purchaseOrder, index) => (
                <tr key={index}>
                  <td>
                    <label className="list-table--checkbox-lable pointer">
                      <input
                        checked={selectedData.includes(purchaseOrder)}
                        type="checkbox"
                        name={purchaseOrder.id}
                        onChange={this.selectSingle}
                      />
                      <span>
                        <Checked />
                      </span>
                    </label>
                  </td>
                  <td>{purchaseOrder.purchase_order_no}</td>
                  <td>{getDate(purchaseOrder.order_date)}</td>
                  <td className="right-align" style={{ paddingRight: '2rem' }}>
                    {purchaseOrder.currency_symbol}
                    {purchaseOrder.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ marginRight: '-1.1rem' }}>
          <FormAction
            onSubmit={() => this.handleSubmit()}
            onCancel={() => onClose()}
            submitLabel="Add"
          />
        </div>
      </Fragment>
    );
  }

  render() {
    return this.renderTable();
  }
}

export default BulkAddIssuedPurchaseOrders;
